export default class DeductCodeSerializer {
  static serialize(data) {
    const payload = {
      ...data,
      id: data.id,
      short_desc: data.shortDescription,
    };

    const customProperties = [
      "deductCodeId",
      "shortDescription"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      id: data.id,
      shortDescription: data.short_desc
    };
  }
}